import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

function linkGroupHandler() {
  const fixedLinkGroup = document.querySelector(`[data-id="fixed-link-group"]`);
  const fbRoot = document.querySelector("#fb-root"); // fb 通訊按鈕

  const footer = document.querySelector(".site-footer");

  if (fbRoot) {
    fbRoot.classList.add("opacity-100", "duration-1000", "transition-all");
  }

  gsap.registerPlugin(ScrollTrigger);

  // 檢測裝置類型
  const isMobileDevice = () => {
    return window.innerWidth < 576; // 瀏覽器寬度)
  };
  const triggerOptions = isMobileDevice()
    ? { start: "top 70%", end: "bottom 70%" } // 手機版設定
    : { start: "top 85%", end: "bottom 70%" }; // 桌機版設定

  const scrollAnim = ScrollTrigger.create({
    trigger: footer,
    triggerOptions,
    // markers: true,
    scrub: true,
    // start 觸發點 向下滾動進入start點時觸發 callback
    onEnter: function () {
      fixedLinkGroup.classList.add("opacity-0", "pointer-events-none");
      if (fbRoot) {
        fbRoot.classList.add("opacity-0", "pointer-events-none");
        fbRoot.classList.remove("opacity-100")
      }
    },
    //start 觸發點 向上滾動進入start點時觸發callback
    onLeaveBack: function () {
      fixedLinkGroup.classList.remove("opacity-0", "pointer-events-none");
      if (fbRoot) {
        fbRoot.classList.remove("opacity-0", "pointer-events-none");
        fbRoot.classList.add("opacity-100")
      }
    },
  });
  return scrollAnim;
}

function caseMobileLinkHandler() {
  const caseMobileLink = document.querySelector(`[data-id='case-mobile-link']`);
  const caseHeader = document.querySelector(`[data-id="case-header"]`);

  gsap.registerPlugin(ScrollTrigger);

  const scrollAnim = ScrollTrigger.create({
    trigger: caseHeader,
    start: "bottom 20%",
    end: "bottom 10%",
    // markers: true,
    scrub: true,
    // start 觸發點 向下滾動進入start點時觸發 callback
    onEnter: function () {
      caseMobileLink.classList.remove("opacity-0", "pointer-events-none");
    },
    //start 觸發點 向上滾動進入start點時觸發callback
    onLeaveBack: function () {
      caseMobileLink.classList.add("opacity-0", "pointer-events-none");
    },
  });
}


export { linkGroupHandler, caseMobileLinkHandler };
